import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import WithRender from '@/Pages/Admin/Modules/ManagePackage/tab/Includes/Views/includes.html';
import GeneralModule from '@/Pages/Admin/Modules/ManagePackage/Store/General';
import {trekService} from '@/Pages/Admin/Modules/ManagePackage/Services/Trekservice';
import {common} from '@/Pages/Admin/Modules/Common/Services/Common';
import ValidationError from '@/Pages/Admin/Modules/Common/Controllers/ValidationError';
import {flashService} from '@/Pages/Admin/Modules/Common/Services/FlashMessage/FlashService';
import {TrekIncludeModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Includes/TrekIncludeModel';


@WithRender
@Component({
    components: {
        'validation-error': ValidationError,
    }
})
export default class Includes extends Vue {
    protected ui: any = {};
    protected item: any = {};

    constructor() {
        super();
        this.ui = {
            index: {
                edit: -1,
                delete: -1,
                up: 0,
                down: 0,
            },
            status: {
                isLoading: {
                    getIncludesList: false,
                },
                postLoading: {
                    create: false,
                    edit: false,
                    delete: false,
                },
                canAdd: false,
                canEdit: false,
            },
            error: {
                errors: {},
                has_error: false,
                error_message: {},
                modal: {
                    delete: {},
                },
            },
        };

        this.item = {
            includesList: new TrekIncludeModel({}),
            addInclude: new TrekIncludeModel({}),
            editInclude: new TrekIncludeModel({}),
            deleteInclude: new TrekIncludeModel({}),
            tempInclude: new TrekIncludeModel({}),
            upInclude: new TrekIncludeModel({}),
            downInclude: new TrekIncludeModel({}),
        };
    }

    public mounted() {
        this.getIncludesList();
    }

    get permission() {
        return common.permissionCheck;
      }

    get getAllIconsList() {
        return GeneralModule.Icons;
    }

    public getIncludesList() {
        let data = {
            trek_id: this.$route.query.id,
        };
        this.ui.status.isLoading.getIncludesList = true;
        trekService
            .getIncludesList(data)
            .then((res: any) => {
                res.data.data.filter((list: any) => {
                    list.IsActive = false;
                });
                this.item.includesList = res.data.data;
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.errors).then((res: any) => {
                    this.ui.error.has_error = true;
                    this.ui.error.errors = res;
                });
            })
            .finally(() => {
                this.ui.status.isLoading.getIncludesList = false;
            });
    }

    protected addIncludes() {
        this.resetError();

        if (!this.validateAddIncludeAction()) {
            return;
        }
        let data = {
            trek_id: this.$route.query.id,
            icon_id: this.item.addInclude.icon.id,
            title: this.item.addInclude.title,
        };
        this.ui.status.postLoading.create = true;
        trekService
            .addIncludes(data)
            .then((res: any) => {
                this.item.includesList.unshift(res.data.data);
                flashService.Success('Includes Added', res.data.message);
                this.ui.status.canAdd = false;
                this.item.addInclude = new TrekIncludeModel({});
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.create = false;
            });
    }

    protected validateAddIncludeAction() {
        let list = this.item.addInclude;
        if (!list.title) {
            Object.assign(this.ui.error.errors, {
                title: ['The title field is required.']
            });
        }
        if (list.icon === null || list.icon.id === 0) {
            Object.assign(this.ui.error.errors, {
                icon_id: ['The icon field is required.']
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected onEditIncludesClick(index: number, list: any) {
        this.resetError();
        this.ui.status.canEdit = true;
        this.item.tempInclude = Object.assign({}, list);
        this.ui.index.edit = index;
        list.IsActive = true;
        this.item.editInclude = list;
    }

    protected editIncludes() {
        this.resetError();

        if (!this.validateEditIncludeAction()) {
            return;
        }
        let data = {
            trek_id: this.$route.query.id,
            id: this.item.editInclude.id,
            icon_id: this.item.editInclude.icon.id,
            title: this.item.editInclude.title,
        };
        this.ui.status.postLoading.edit = true;
        trekService
            .editIncludes(data)
            .then((res: any) => {
                this.ui.status.canEdit = false;
                this.$set(this.item.includesList, this.ui.index.edit, res.data.data);
                flashService.Success('Include Edited', res.data.message);
                this.resetError();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.error_message).then(res => {
                    this.ui.error.error_message = res;
                });
            })
            .finally(() => {
                this.ui.status.canEdit = false;
                this.ui.status.postLoading.edit = false;
            });
    }

    protected validateEditIncludeAction() {
        let list = this.item.editInclude;
        if (!list.title) {
            Object.assign(this.ui.error.errors, {
                edit_title: ['The title field is required.']
            });
        }
        if (list.icon === null || list.icon.id === 0) {
            Object.assign(this.ui.error.errors, {
                edit_icon_id: ['The icon field is required.']
            });
        }
        if (common.notEmpty(this.ui.error.errors)) {
            this.ui.error.has_error = true;
            return false;
        } else {
            return true;
        }
    }

    protected cancelIncludes(index: number, list: any) {
        this.resetError();
        this.ui.status.canEdit = false;
        list.IsActive = false;
        this.ui.index.edit = index;
        this.item.includesList[index] = this.item.tempInclude;
    }


    protected onDeleteIncludesClick(index: any, list: any) {
        this.resetError();
        this.ui.status.canEdit = false;
        $('#deleteSelectedIncludes').modal('show');
        this.ui.index.delete = index;
        this.item.deleteInclude = list;
    }


    protected deleteIncludes() {
        this.resetError();
        let data = {
            trek_id: this.$route.query.id,
            id: this.item.deleteInclude.id
        };
        this.ui.status.postLoading.delete = true;
        trekService
            .deleteSelectedIncludes(data)
            .then((res: any) => {
                this.$delete(this.item.includesList, this.ui.index.delete);
                flashService.Success('Include Deleted', res.data.message);
                this.hideDeleteModal();
            })
            .catch((error: any) => {
                common.sdCatchErr(error, this.ui.error.modal.delete).then(res => {
                    this.ui.error.modal.delete = res;
                });
            })
            .finally(() => {
                this.ui.status.postLoading.delete = false;
            });
    }

    protected hideDeleteModal() {
        $('#deleteSelectedIncludes').modal('hide');
        $('.modal-backdrop').remove();
        this.ui.error.modal.delete = {};
        this.resetError();
    }

    public resetError() {
        this.ui.error.errors = {};
        this.ui.error.has_error = false;
        this.ui.error.error_message = {};
    }

    public customLabel(name: any) {
        return name;
    }

    public get buttonTextAddInclude() {
        if (this.ui.status.postLoading.create) {
            return 'Processing...';
        }
        return 'Save Includes';
    }


    protected showAddIncludeButton() {
        this.ui.status.canAdd = true;
    }

    protected moveIncludeUp(index: any, destination: any) {
        this.item.upInclude = this.item.includesList[index - 1];
        this.ui.index.up = index - 1;
        this.resetError();
        this.$set(this.item.includesList, this.ui.index.up, destination);
        this.$set(this.item.includesList, index, this.item.upInclude);
    }

    protected moveIncludeDown(index: any, destination: any) {
        this.item.downInclude = this.item.includesList[index + 1];
        this.ui.index.down = index + 1;
        this.resetError();
        this.$set(this.item.includesList, this.ui.index.down, destination);
        this.$set(this.item.includesList, index, this.item.downInclude);
    }
}
